import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-client-dashboard',
  templateUrl: './client-dashboard.component.html',
  styleUrls: ['./client-dashboard.component.scss'],
})
export class ClientDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  onDestroyNotifier$ = new Subject();
  clientDetailsSheetActive = false;
  sentMailDataSheetValue = false;
  openCreateMailSheetValue = false;
  addPropertySearchValue = false;
  isValueTestCompany: boolean = false;
  isOpScanCompany: boolean = false;
  clientMarketingDetailsSheetActive = false;
  openPropertyListingValue = false;
  isMarketingTrue = false;
  changeTab: any;
  changeTab4: any;
  openAddContactNoteSheetValue: any;
  redirectTabId: any;
  companyAppConfig: any;
  queryParam: any;
  tabReloaded: boolean = false;
  openAddExpiredListingsNoteSheetValue: boolean = false;
  tabIndex: number = 0;
  displayExpiredListings: boolean = false;
  isAgent: boolean = false;
  companyName: any;


  constructor(
    private clientDashboardState: ClientDashboardState,
    public authorizeService: AuthorizeService,
    private appState: AppState,
    private route: ActivatedRoute,
    private userState: UserState,
    private cdr: ChangeDetectorRef,
    private clientDashboardService: ClientDashboardService,
    private router: Router

  ) { }
  private onDestroyNotifier: Subject<any> = new Subject<any>();

  ngOnInit() {

    this.route.queryParams.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((params) => {
      const isLoggedIn = !!this.appState.authTokenValue?.accessToken;
      this.queryParam = params;
      // Email flow
      if (params?.email) {
        if (!isLoggedIn) {
          this.authorizeService.openLogInDialog();
        } else {
          setTimeout(() => {
            this.selectTabByLabel('activeClients');
          });
        }
      }
      this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
        if (res) {

          // const clientData = this.constructClientDetailSheet()
          if (res?.userType == 'agent') {
            this.isAgent = true;
          }
        }
      });
      // ID flow
      if (params?.id && !isLoggedIn) {
        this.authorizeService.openLogInDialog();
      }

      // Redirect tab
      if (params?.redirectTo) {
        this.redirectTabId = params.redirectTo;
      }

      if (this.queryParam.openClientDetails && this.appState.authTokenValue?.accessToken && this.queryParam.encryptedData) {
        this.clientDashboardService.decryptClientDetails({ identifier: this.queryParam.encryptedData }).subscribe((res: any) => {
          this.clientDashboardState.activeClientDetailsValue = res.data
        })
        this.clientDashboardState.openClientDetailsSheetValue = true;

      }

    });




    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res) {
        this.companyName = res.alias;
        this.companyAppConfig = res?.appConfig;
        if (this.companyAppConfig?.expiredListings?.enabled) {
          this.displayExpiredListings = true;
        }
        if (this.companyAppConfig?.valueReport?.isEnabled && res.alias === 'valuetest') {
          this.isValueTestCompany = true;
        } else {
          this.isValueTestCompany = false;
        }
        if (this.companyAppConfig?.opportunityScanner?.isEnabled && res.alias === 'opscan') {
          this.isOpScanCompany = true;
        } else {
          this.isOpScanCompany = false;
        }
      }
    });

    this.route.queryParamMap
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(params => {
        const tab = params.get('tab');
        if (tab == 'expiredListings') {
          this.tabIndex = 6;

        } else if (tab == 'clients' || tab == 'myClients') {

          if (this.companyName == 'valuetest' || this.companyName == 'opscan') {
            this.tabIndex = 0;
          } else {
            this.tabIndex = 1;
          }
        }
        else if (tab == 'leads') {
          this.tabIndex = 0;
        }
        else if (tab == 'partners') {
          this.tabIndex = 2;
        }
        else if (tab == 'referrals') {
          this.tabIndex = 1;
        }
        else {
          this.tabIndex = 0;

        }
      });


    this.clientDashboardState.openClientDetailsSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.clientDetailsSheetActive = status;
      if (this.clientDetailsSheetActive && !this.isValueTestCompany) this.selectTabByLabel('activeClients');
    });
    this.clientDashboardState.openSentMailDataSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.sentMailDataSheetValue = status;
    });
    this.clientDashboardState.openCreateMailSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openCreateMailSheetValue = status;
    });
    // this.clientDashboardState.openAddContactNoteSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
    //   this.openAddContactNoteSheetValue = status;
    // });
    this.clientDashboardState.openAddExpireListingsNoteSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openAddExpiredListingsNoteSheetValue = status;
    });
    this.clientDashboardState.openAddSavedSearchSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.addPropertySearchValue = status;
    });
    this.clientDashboardState.openMarketingEffectivenessSheet$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((status) => {
        this.clientMarketingDetailsSheetActive = status;
      });
    this.clientDashboardState.openPropertyDetailsSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openPropertyListingValue = status;
    });
  }

  selectTabByLabel(tabId: string): void {
    if (!this.tabGroup || !this.tabGroup._tabs?.length) {
      return;
    }

    const index = this.tabGroup._tabs
      .toArray()
      .findIndex(tab => tab.ariaLabel?.toLowerCase() === tabId.toLowerCase());

    if (index !== -1) {
      this.tabGroup.selectedIndex = index;
    }
  }

  openClientSheet(value) {
    this.changeTab = value;
    if (this.changeTab.length) {
      this.selectTabByLabel('activeClients');
    }
  }

  openMarketingSheet(value) {
    this.changeTab4 = value;
    if (this.changeTab4.length) {
      this.selectTabByLabel('marketingEffectiveness');
    }
  }

  ngAfterViewInit() {
    this.userState.userDetail$
      .pipe(
        takeUntil(this.onDestroyNotifier),
        filter((res) => res !== null),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
      )
      .subscribe((res) => {
        if (res && this.queryParam?.redirectTo) {
          this.selectTabByLabel(this.queryParam?.redirectTo);
          this.cdr.detectChanges();
        }
      });

    if (this.redirectTabId) {
      this.selectTabByLabel(this.redirectTabId);
    }

    this.tabGroup._tabs.changes.subscribe(() => {
      if (this.redirectTabId) {
        this.selectTabByLabel(this.redirectTabId);
      }
    });
  }

  tabChange(event: MatTabChangeEvent) {
    if (event.index == 4) {
      this.isMarketingTrue = true;
      this.clientDashboardState.clickedThroughValue = this.changeTab4;
    } else {
      this.clientDashboardState.clickedThroughValue = null;
    }

    if (event.tab.ariaLabel === 'activeClients') {
      this.updateUrl('myClients');
    }
    if (event.tab.ariaLabel === 'leadDashboard') {
      this.updateUrl('leads');
    }
    if (event.tab.ariaLabel === 'partners') {
      this.updateUrl('partners');
    }
  }

  updateUrl(tabName: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab: tabName }
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
